module.exports = __webpack_public_path__ + "hbomaxar-static/media/FlightAttendant_logo.8c179bfa.png";